import React, { ReactNode } from "react";

import { IgButton, IgTypography } from "@intelligems/ig-theme";

import { AreYouSure } from "../../components/Popover/AreYouSure";

interface CancelButtonProps {
  keyId: string;
  handleYesClick: () => void;
  hoverText?: ReactNode;
  cancelText?: string;
  isLoading: boolean;
  yesMessage?: string;
}

export const CancelButton = ({
  handleYesClick,
  hoverText,
  cancelText,
  isLoading,
  yesMessage,
  keyId,
}: CancelButtonProps) => {
  return (
    <AreYouSure
      enabled={true}
      keyId={keyId}
      buttonText={"Cancel"}
      isLoading={isLoading}
      onYesClick={handleYesClick}
      message={hoverText}
      yesMessage={yesMessage}
    >
      <IgButton
        loading={isLoading}
        variant={"outlined"}
        igVariant={"error"}
        size={"small"}
      >
        {cancelText || "Cancel"}
      </IgButton>
    </AreYouSure>
  );
};
